import { Routes } from "@/types/routes";
import { TransactionStatus } from "@/types/receipt";
import { playSound, SoundOption } from "@/helpers/playSound";
import router from "@/helpers/router";
import { store } from "@/store";
import { setPaid } from "@/store/receipt/slice";

export interface TransactionUpdate {
  state: TransactionStatus;
}

export type WebsocketErrorListener = () => void;

export abstract class TransactionSocketHandler {
  protected listeners: WebsocketErrorListener[] = [];

  protected onStatusUpdate = async ({ state }: TransactionUpdate) => {
    this.closeConnection();
    if (state === TransactionStatus.SUCCESS) {
      store.dispatch(setPaid());
      playSound(SoundOption.PaymentSuccess);
      return await router.navigate(Routes.SUCCESS);
    }
    if (state === TransactionStatus.CANCELLED) playSound(SoundOption.PaymentCanceled);
    else if (state === TransactionStatus.ERROR) playSound(SoundOption.PaymentError);
    // We want to show the error screen if the payment was cancelled, because then the big red screen will be shown
    this.listeners.forEach((listener) => listener());
  };

  public addWsErrorListener(listener: WebsocketErrorListener) {
    this.listeners.push(listener);
  }

  public removeWsErrorListener(listener: WebsocketErrorListener) {
    const index = this.listeners.indexOf(listener);
    if (index === -1) return;
    this.listeners.splice(index, 1);
  }

  abstract openConnection(receiptId: number): void;

  abstract isConnected(): boolean;

  abstract closeConnection(): void;
}
